import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function getChargingAssignmentQueue ({ chargePointId, transportationProfileId, idTag, dateFrom, dateTo, order, limit } = {}) {
  return apiRequests.get('/v1/ocpp-transaction/charging-sessions/assignment-queue', {
    params: {
      chargePointId: chargePointId || undefined,
      transportationProfileId: transportationProfileId || undefined,
      idTag: idTag || undefined,
      dateFrom: dateFrom || undefined,
      dateTo: dateTo || undefined,
      order: order || undefined,
      limit: limit || undefined
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function assignChargingSession ({
  transactionId,
  transportationProfileId,
  idTag,
  vehicleClass,
  applyToIdTag,
  notes
}) {
  return apiRequests.post('/v1/ocpp-transaction/charging-sessions/' + transactionId + '/assignment', {
    transportationProfileId,
    idTag: idTag || undefined,
    vehicleClass: vehicleClass || undefined,
    applyToIdTag: applyToIdTag,
    notes: notes || undefined
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function searchAssignableTransportationProfiles ({ keywords, limit } = {}) {
  return apiRequests.get('/v1/ocpp-transaction/charging-assignments/transportation-profiles', {
    params: {
      keywords: keywords || undefined,
      limit: limit || undefined
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function startProvisioning ({ idTag }) {
  return apiRequests.post('/v1/ocpp-id-tag/' + encodeURIComponent(idTag) + '/start-provisioning', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function finalizeProvisioning ({ idTag }) {
  return apiRequests.post('/v1/ocpp-id-tag/' + encodeURIComponent(idTag) + '/finalize-provisioning', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function reProvision ({ idTag }) {
  return apiRequests.post('/v1/ocpp-id-tag/' + encodeURIComponent(idTag) + '/re-provision', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function reviewFingerprintMismatch ({ id, decision, expandedTolerance, notes }) {
  return apiRequests.post('/v1/ocpp-fingerprint-mismatch/' + id + '/review', {
    decision: decision,
    expandedTolerance: expandedTolerance || undefined,
    notes: notes || undefined
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function assignVehicleToCharger ({ chargePointId, transportationProfileId }) {
  return apiRequests.post('/v1/ocpp-charger/' + encodeURIComponent(chargePointId) + '/assign-vehicle', {
    transportationProfileId
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function releaseVehicleFromCharger ({ chargePointId }) {
  return apiRequests.post('/v1/ocpp-charger/' + encodeURIComponent(chargePointId) + '/release-vehicle', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getActiveChargerAssignments () {
  return apiRequests.get('/v1/ocpp-charger/assignments/active', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getVehicleChargingStatus ({ transportationProfileId }) {
  return apiRequests.get('/v1/ocpp-charger/assignments/vehicle-status', {
    params: { transportationProfileId },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getChargerChargingHistory ({ id, licensePlate, dateFrom, dateTo, limit, skip, order }) {
  return apiRequests.get('/v1/ocpp-charger/' + id + '/charging-history', {
    params: {
      licensePlate: licensePlate || undefined,
      dateFrom: dateFrom || undefined,
      dateTo: dateTo || undefined,
      limit: limit || undefined,
      skip: skip || undefined,
      order: order || undefined
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function countChargerChargingHistory ({ id, licensePlate, dateFrom, dateTo }) {
  return apiRequests.get('/v1/ocpp-charger/' + id + '/charging-history/count', {
    params: {
      licensePlate: licensePlate || undefined,
      dateFrom: dateFrom || undefined,
      dateTo: dateTo || undefined
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export {
  getChargingAssignmentQueue,
  assignChargingSession,
  searchAssignableTransportationProfiles,
  startProvisioning,
  finalizeProvisioning,
  reProvision,
  reviewFingerprintMismatch,
  assignVehicleToCharger,
  releaseVehicleFromCharger,
  getActiveChargerAssignments,
  getVehicleChargingStatus,
  getChargerChargingHistory,
  countChargerChargingHistory
}
